export default __webpack_public_path__ + "img/rebates.eec90c6c.svg";